<!--
    @desc 全站全局变量,在vue环境内可直接用this访问
    @author tlh
    @time 2020-11-05
--->
<script>
// 查询条件相差间隔（天数）
const TIMEINTERVAL = 60;

//默认查询开始日期，目前为7天前，负数为前时间，正数的话为后时间。
const TIMESTARTSEARCH = -7;

//权限变量
var power = {}

//也是是否处于激活状态，1激活，2非激活，null未知
var FOCUSPAGE = null
var TIME_1 = null

export default{
    TIMEINTERVAL,
    TIMESTARTSEARCH,
    power,
    FOCUSPAGE
}
</script>


// WEBPACK FOOTER //
// Global.vue?d9713206